import { render } from "./Mas.vue?vue&type=template&id=2fd4306b&scoped=true"
import script from "./Mas.vue?vue&type=script&lang=js"
export * from "./Mas.vue?vue&type=script&lang=js"

import "./Mas.vue?vue&type=style&index=0&id=2fd4306b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd4306b"]])

export default __exports__